(function () {
  function init() {
    var sections = document.querySelectorAll('main .shopify-section');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || reduceMotion) {
      sections.forEach(function (s) { s.classList.add('scroll-reveal-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -80px 0px' }
    );

    sections.forEach(function (section, index) {
      if (index === 0) {
        section.classList.add('scroll-reveal-visible');
      } else {
        observer.observe(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
